import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { QualificationTrainingsStatus } from '@wilson/interfaces';
import { Observable, of } from 'rxjs';
import { BaseSelectFilterDirective } from '../../base-select-filter.directive';
import { FilterService } from '../../filter.service';
import { FilterOptions } from '../../options.interface';
import { MultiSelectParserService } from '../../services/multi-select-parser.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { NzSelectModule } from 'ng-zorro-antd/select';

@Component({
  selector: 'wilson-training-qualification-v2-status-filter',
  templateUrl: './training-qualification-v2-status-filter.component.html',
  styleUrls: ['./training-qualification-v2-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzSelectModule, TranslatePipe, CommonModule, FormsModule],
})
export class TrainingQualificationV2StatusFilterComponent extends BaseSelectFilterDirective<
  FilterOptions,
  string[]
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService = inject(MultiSelectParserService);

  public options: FilterOptions[] = [
    {
      name: `page.training-qualifications.status.booked`,
      id: QualificationTrainingsStatus.booked,
    },
    {
      name: `page.training-qualifications.status.cancelled`,
      id: QualificationTrainingsStatus.cancelled,
    },
    {
      name: `page.training-qualifications.status.completed_failed`,
      id: QualificationTrainingsStatus.completedFailed,
    },
    {
      name: `page.training-qualifications.status.completed_success`,
      id: QualificationTrainingsStatus.completedSuccess,
    },
    {
      name: `page.training-qualifications.status.declined`,
      id: QualificationTrainingsStatus.declined,
    },
    {
      name: `page.training-qualifications.status.in_progress`,
      id: QualificationTrainingsStatus.inProgress,
    },
    {
      name: `page.training-qualifications.status.open`,
      id: QualificationTrainingsStatus.open,
    },
    {
      name: `page.training-qualifications.status.paused`,
      id: QualificationTrainingsStatus.paused,
    },
    {
      name: `page.training-qualifications.status.pending`,
      id: QualificationTrainingsStatus.pending,
    },
    {
      name: `page.training-qualifications.status.qualification_created`,
      id: QualificationTrainingsStatus.qualificationCreated,
    },
    {
      name: `page.training-qualifications.status.result_accepted`,
      id: QualificationTrainingsStatus.resultAccepted,
    },
    {
      name: `page.training-qualifications.status.result_rejected`,
      id: QualificationTrainingsStatus.resultRejected,
    },
  ];

  constructor() {
    super('qualificationTrainingsStatus');
  }

  protected initializeOptions(): Observable<FilterOptions[]> {
    return of(this.options);
  }
}
